export const environment = {
  'production': true,
  'proxy': 'https://proxy-dev.swaas.de',
  'mcp': 'https://mcp.swaas.de/',
  'MCP_CLIENTS_JSON': 'https://mcp.swaas.de/clients.json',
  'clientID': 600,
  'apiURL': 'https://vbh-hoy-dev-api.plusservices.de',
  'appVersion': require('../../package.json').version,
  'ngVersion': require('../../package.json').dependencies['@angular/pwa'],
  'appName' : 'Versorgungswerke Hoyerswerda Dashboard'
}
